import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';

@Injectable()
export class UserDeleteService {

  private deleteAccountApiUrl = APP_SETTINGS.DeleteAccountApiUrl;
  constructor(
    private executeService: ExecuteService) {
  }

  public DeleteUser(email: string): Observable<any> {

    const url = this.deleteAccountApiUrl;
    const body = { email: email };

    return this.executeService.ExecuteWithToken('post', url, null, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/users/services/userDelete.service.ts